import { sendAdobeEvent } from './adobeAnalitycs';

const BASE = {
  CO: {
    experience: {
      category: 'External Public Site',
      product: 'Pollos Bucanero',
      region: 'LATAM',
      country: 'Colombia',
      language: 'ES-CO',
    },
  },
  HN: {
    experience: {
      category: 'External Public Site',
      product: 'Pollo Norteño',
      region: 'LATAM',
      country: 'Honduras',
      language: 'ES-HN',
    },
  },
};

export const adobeSearchBtnProcessStart = (countryCode, batchCode) => {
  // location: search batch button
  sendAdobeEvent({
    event: 'Process Start',
    ...BASE[countryCode],
    element: {
      id: batchCode,
    },
    process: {
      name: 'Track Your Chicken',
      id: batchCode,
    },
  });
};

export const adobeSearchBtnProcessComplete = (countryCode) => {
  // location: video slider, arrow next, only if is the last video
  sendAdobeEvent({
    event: 'Process Complete',
    ...BASE[countryCode],
    process: {
      name: 'Track Your Chicken',
    },
  });
};
